import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plugs, WhatsappLogo, ArrowRight } from "@phosphor-icons/react";
import { ZohoCard } from "@/components/ZohoConnect";
import { CapiCard } from "@/components/CapiCard";
import { SpeedToLead } from "@/components/SpeedToLead";
import { api } from "@/lib/api";

const MetaCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/meta/status").then(({ data }) => setS(data)).catch(() => setS({})); }, []);
  const live = s?.connected;
  return (
    <div className="rounded-xl border border-[#E5E7EB] bg-white p-5" data-testid="integration-meta-card">
      <div className="flex items-center gap-3">
        <span className="h-10 w-10 rounded-lg bg-[#0052FF]/10 flex items-center justify-center"><Plugs size={20} weight="duotone" className="text-[#0052FF]" /></span>
        <div className="mr-auto min-w-0">
          <div className="font-bold text-sm text-[#0A0D14]">Meta Marketing API</div>
          <div className="text-[11px] text-[#8a90a0] truncate" data-testid="integration-meta-status">
            {!s ? "Checking…" : live ? `Connected · ${s.account_count} live ad account${s.account_count === 1 ? "" : "s"} · full sync every 3h + 5-min lead poll` : "Not connected — connect to pull live campaigns, ads and leads"}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {live && <span className="rounded-full bg-success/10 text-[#00953e] text-[10px] font-bold px-2.5 py-1">LIVE</span>}
          <Link to="/connect" data-testid="integration-meta-manage"
            className={`inline-flex items-center gap-1.5 rounded-full text-[11px] font-bold px-3.5 py-2 ${live ? "border border-[#E5E7EB] text-[#525866] hover:bg-[#F3F4F6]" : "bg-[#0052FF] text-white hover:bg-[#0043d1]"}`}>
            {live ? "Manage" : "Connect"} <ArrowRight size={12} weight="bold" />
          </Link>
        </div>
      </div>
    </div>
  );
};

const GallaboxCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/speedlead/settings").then(({ data }) => setS(data)).catch(() => setS({})); }, []);
  return (
    <div className="rounded-xl border border-[#E5E7EB] bg-white p-5" data-testid="integration-gallabox-card">
      <div className="flex items-center gap-3">
        <span className="h-10 w-10 rounded-lg bg-[#25D366]/10 flex items-center justify-center"><WhatsappLogo size={20} weight="fill" className="text-[#25D366]" /></span>
        <div className="mr-auto min-w-0">
          <div className="font-bold text-sm text-[#0A0D14]">WhatsApp Auto-Reply · Gallabox</div>
          <div className="text-[11px] text-[#8a90a0] truncate" data-testid="integration-gallabox-status">
            {!s ? "Checking…" : s.enabled ? `ON · template "${s.template_name}" · new leads messaged within ~5 minutes` : "Message every new Facebook lead on WhatsApp within 5 minutes"}
          </div>
        </div>
        <div className="shrink-0"><SpeedToLead /></div>
      </div>
    </div>
  );
};

export default function Integrations() {
  return (
    <div className="space-y-6 max-w-4xl" data-testid="integrations-page">
      <div>
        <h2 className="font-heading text-lg font-extrabold tracking-tight text-[#0A0D14]">Data sources</h2>
        <p className="text-xs text-[#8a90a0] mt-0.5">Where your campaigns, leads and sales outcomes come from.</p>
        <div className="mt-3 space-y-3">
          <MetaCard />
          <ZohoCard />
        </div>
      </div>
      <div>
        <h2 className="font-heading text-lg font-extrabold tracking-tight text-[#0A0D14]">Actions & tracking</h2>
        <p className="text-xs text-[#8a90a0] mt-0.5">What happens automatically when leads and admissions arrive.</p>
        <div className="mt-3 space-y-3">
          <GallaboxCard />
          <CapiCard />
        </div>
      </div>
      <p className="text-[11px] text-[#8a90a0]">Zoho sync, WhatsApp auto-reply, CAPI events and audience refresh all run on the automatic 3-hour cycle (leads are polled every 5 minutes when WhatsApp auto-reply is on).</p>
    </div>
  );
}
